import { createContext, useContext } from 'react';

type PrintContextValue = {
  forceExpandAccordions: boolean;
};

const PrintContext = createContext<PrintContextValue>({ forceExpandAccordions: false });

export const PrintContextProvider = PrintContext.Provider;

export const useForceExpandAccordions = () => useContext(PrintContext).forceExpandAccordions;
